import {GifActions} from "../constants/gifActions";

const INITIAL_STATE = {

    Gifs: []
};
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GifActions.GET_GIFS:
            console.log(state.Gifs , 'aaaaaaaaaaaa')
            console.log(action.payload.Gifs , 'payloooad')

            return { ...state, Gifs: [...state.Gifs , action.payload.Gifs]  };
        case GifActions.GIF_ERROR:
            return { ...state, errorMessage: action.payload };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/pagination.ts